import React from 'react';
import { ClassAssembly12D2025 } from '../views';


const ClassAssemblyPage = () => {
    return <ClassAssembly12D2025/>;
  };
  
  export default ClassAssemblyPage;